module.exports = __webpack_public_path__ + "static/img/url3.dbb5c43b.png";